import { findTenantConfigContent } from './globalFollowSettings';

export const PAYMENT_SETTING_CONFIG_KEY = 'paymentSetting';

export const DEFAULT_PAYMENT_PARAMETERS = {
  withdrawMinPrice: 0,
  withdrawMaxPrice: 0,
  withdrawFee: 0,
};

/**
 * 從 tenant_config 表（經 GET /memberEnt/tenant-config）解析充提參數。
 * 對應 item_key = 'paymentSetting' 的 content 欄位（PaymentSettingConfig）。
 */
export function normalizePaymentSettingConfig(content) {
  const source = content && typeof content === 'object' ? content : {};
  const params = source.paymentParametersSetting && typeof source.paymentParametersSetting === 'object'
    ? source.paymentParametersSetting
    : {};

  return {
    withdrawMinPrice: Number(params.withdrawMinPrice) || 0,
    withdrawMaxPrice: Number(params.withdrawMaxPrice) || 0,
    /** 提款手續費比例，如 0.01 = 1% */
    withdrawFee: Number(params.withdrawFee) || 0,
  };
}

export function pickPaymentSettingFromTenantList(list) {
  return normalizePaymentSettingConfig(findTenantConfigContent(list, PAYMENT_SETTING_CONFIG_KEY));
}
